export default "__VITE_ASSET__D$oSDby$__"